import React from 'react';

import { useAsync } from 'react-use';
import { redirectToLogin, redirectToSignup } from 'src/auth';

import { AppLoading } from './AppLoading';

export function Login(): JSX.Element {
  useAsync(async () => {
    await redirectToLogin();
  }, []);

  return <AppLoading waitingText="Redirecting to login..." />;
}

export function Signup(): JSX.Element {
  useAsync(async () => {
    await redirectToSignup();
  }, []);

  return <AppLoading waitingText="Redirecting to signup..." />;
}
